var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3536 6.64645C20.5488 6.84171 20.5488 7.15829 20.3536 7.35355L11.7678 15.9393C10.7915 16.9157 9.20855 16.9157 8.23223 15.9393L4.64645 12.3536C4.45118 12.1583 4.45118 11.8417 4.64645 11.6464C4.84171 11.4512 5.15829 11.4512 5.35355 11.6464L8.93934 15.2322C9.52513 15.818 10.4749 15.818 11.0607 15.2322L19.6464 6.64645C19.8417 6.45118 20.1583 6.45118 20.3536 6.64645Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckLight);
export default __webpack_public_path__ + "static/media/check-light.3afb070736cf46cd9635edf9e47a735a.svg";
export { ForwardRef as ReactComponent };